import { Tabs } from "antd"
import TabPane from "antd/lib/tabs/TabPane"
import React from "react"
import { ConnectionLogs } from "./ConnectionLogs"

export function LogsGeneral() {

    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Connexions aux outils" key="1">
                <ConnectionLogs />
            </TabPane>
        </Tabs>
    )
}